// African countries list for payment provider detection
const AFRICAN_COUNTRIES = [
  'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CV', 'CF', 'TD', 'KM', 'CG', 'CD', 'DJ', 'EG', 'GQ', 'ER', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'CI', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'YT', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'RE', 'SH', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'SZ', 'TZ', 'TG', 'TN', 'UG', 'EH', 'ZM', 'ZW'
];

export interface LocationInfo {
  country: string;
  isAfrican: boolean;
  paymentProvider: 'paystack' | 'stripe';
}

/**
 * Detect user location and determine appropriate payment provider
 */
export async function detectUserLocation(): Promise<LocationInfo> {
  try {
    // Try to get location from IP geolocation
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    const country = data.country_code || 'NG'; // Default to Nigeria if detection fails
    const isAfrican = AFRICAN_COUNTRIES.includes(country);
    
    return {
      country,
      isAfrican,
      paymentProvider: isAfrican ? 'paystack' : 'stripe'
    };
  } catch (error) {
    console.warn('Location detection failed, defaulting to Paystack:', error);
    // Default to Paystack (African provider) if detection fails
    return {
      country: 'NG',
      isAfrican: true,
      paymentProvider: 'paystack'
    };
  }
}

/**
 * Get payment provider based on country code
 */
export function getPaymentProvider(countryCode: string): 'paystack' | 'stripe' {
  return AFRICAN_COUNTRIES.includes(countryCode) ? 'paystack' : 'stripe';
}

/**
 * Check if a country is in Africa
 */
export function isAfricanCountry(countryCode: string): boolean {
  return AFRICAN_COUNTRIES.includes(countryCode);
} 